module.exports = __webpack_public_path__ + "static/img/big-img.0c3cf78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lowCodePhone/big-img.png
// module id = BL/8
// module chunks = 0